export default __webpack_public_path__ + "static/media/icon_calendar_on.83322035.svg";